module.exports = {
  optionsData: () => {
    return{
      "IONIQ 5 EV-POWER": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "TUCSON HEV LIMITED": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "PALISADE SPORT": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "STARIA LUJO": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "VENUE LIMITED AT": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "HB20 ADVANCE": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "HB20S ADVANCE": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },
      "CRETA PREMIUM": {
        // "PROMOCIONAL":{
        //   "Icon": require("./../UI/options/Icon_promocionales.svg"),
        //   "name":"Video",
        //   "slug": 'video'
        // },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },
      "KONA HEV LIMITED": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "SANTA FE HEV LIMITED 4x4": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

      "GRAND i10 AT PREMIUM": {
        "PROMOCIONAL":{
          "Icon": require("./../UI/options/Icon_promocionales.svg"),
          "name":"Video",
          "slug": 'video'
        },
        "FICHA":{
          "Icon": require("./../assets/icons/info.svg"),
          "name":"Ficha técnica",
          "slug": "ficha"
        },
        "COTIZA":{
          "Icon": require("./../assets/icons/quotation.svg"),
          "name":"Cotiza",
          "slug": "cotiza"
        },
        "PRESENTACION":{
          "Icon": require("./../UI/options/Icon_Presentacion.svg"),
          "name": "Conoce el vehículo",
          "slug": "modelo"
        }
      },

    }
  }
}